import type { ReactNode } from "react";

export const AuthCard = ({
  title,
  children,
}: {
  title: string;
  children: ReactNode;
}) => (
  <section className="flex min-h-svh items-center justify-center bg-[#F1F5F9] p-6">
    <div className="w-full max-w-sm space-y-6 rounded-xl bg-white px-8 py-12 text-center shadow-xl">
      <h2 className="text-xl text-[#2D3748]">{title}</h2>
      {children}
    </div>
  </section>
);
